<template>
  <b-container class="rakenneTyypit my-4 no-print" v-if="items.length">
    <b-row>
      <b class="my-4">Rakennetyypit</b>
    </b-row>

    <b-row class="tyypit tyypit-row" v-for="(row) in rakenneTyypit" :key="row.id" v-if="getItems(row).length">
      <b-col cols="2" class="row-label">
        <span>{{row.title}}</span>
      </b-col>
      <div class="prev-wrapper">
        <font-awesome-icon
          icon="arrow-circle-left"
          size="2x"
          class="page-button"
          v-if="row.previous !== null"
          @click="row.page=row.previous"
        ></font-awesome-icon>
      </div>
      <b-col cols="2" v-for="(item, index) in listItems(row)" :key="index">
        <b-img
          v-if="item.id !== '' && item.acf.kaavio"
          @click="openModal(item)"
          :src="item.acf.kaavio"
          class="img-fluid"
          :title="item.acf.tunnus"
        ></b-img>
      </b-col>
      <div class="next-wrapper">
        <font-awesome-icon
          icon="arrow-circle-right"
          size="2x"
          class="page-button"
          v-if="row.next !== null"
          @click="row.page=row.next"
        ></font-awesome-icon>
      </div>
    </b-row>
    <Modal
      :item="modalItem"
      :paloluokka="plName"
      :pintaluokat="pintaluokat"
      :kayttotarkoitus="kayttotarkoitus"
      @pdf="makePDF()"
      @print="printPage()"
    />
  </b-container>
</template>
<script>
import * as jsPDF from 'jspdf'
import LiberationSans from '../assets/LiberationSans-normal'
import LiberationSansBold from '../assets/LiberationSans-bold'
import Modal from './Modal.vue'
import { fields, paloluokat } from '../data/constants.js'

export default {
  name: 'Tyypit',
  components: { Modal },
  props: {
    items: Array,
    kayttotarkoitus: String,
    paloluokka: String,
    pintaluokat: Object
  },
  data () {
    return {
      modalItem: {},
      fields: fields,
      paloluokat: paloluokat,
      rakenneTyypit: [
        {
          title: 'Ulkoseinä',
          typeId: 20,
          page: 0,
          pages: 1,
          previous: null,
          next: null
        },
        {
          title: 'Väliseinä',
          typeId: 21,
          page: 0,
          pages: 1,
          previous: null,
          next: null
        },
        {
          title: 'Välipohja',
          typeId: 22,
          page: 0,
          pages: 1,
          previous: null,
          next: null
        },
        {
          title: 'Yläpohja',
          typeId: 23,
          page: 0,
          pages: 1,
          previous: null,
          next: null
        }
      ]
    }
  },
  computed: {
    plName: function () {
      for (var i = 0; i < this.paloluokat.length; i++) {
        const palo = this.paloluokat[i]
        if (this.paloluokka === palo.index) {
          return palo.class + ' (' + palo.value + ')'
        }
      }
      return 'Placeholder'
    }
  },
  methods: {
    openModal (item) {
      // console.debug('Click')
      this.modalItem = item
      this.$bvModal.show('modal_tyyppi')
    },
    getItems (type) {
      return this.items.filter(function (item) {
        return item.acf.tyyppi === type.typeId
      })
    },
    listItems (type) {
      const perPage = 5
      const items = this.getItems(type)
      const returnItems = items.slice(
        perPage * type.page,
        perPage * type.page + perPage
      )
      if (returnItems.length < perPage) {
        for (let i = returnItems.length; i < perPage; i++) {
          returnItems.push({ id: '' })
        }
      }
      type.previous = type.page > 0 ? type.page - 1 : null
      type.next =
        items.length > (type.page + 1) * perPage ? type.page + 1 : null
      type.pages = Math.ceil(items.length / perPage)
      return returnItems
    },
    printPage () {
      this.$router.push('/print/' + this.modalItem.id + '/' + this.paloluokka)
    },
    drawHeader (doc, pos, rowHeight, xOffset, yOffset) {
      doc.setFontStyle('bold')
      this.fields.forEach((field, col) => {
        doc.setDrawColor(0, 0, 0, 120)
        doc.rect(pos[0], pos[1], field.width, rowHeight, 'S')
        doc.setDrawColor(0, 0, 0, 250)
        doc.text(field.label, pos[0] + xOffset, pos[1] + yOffset)
        pos[0] += field.width
      })
      doc.setFontStyle('normal')
    },
    formatContent (content, rowNr) {
      if (typeof content === 'undefined') {
        content = '' + (rowNr + 1)
      }
      if (typeof content !== 'string') {
        if (content.length > 1) {
          content = content[0].name + '\n' + content[1].name
        } else if (content.length > 0) {
          content = content[0].name
        }
      }
      if (typeof content !== 'string') {
        content = ''
      }
      return this.cleanContent(content)
    },
    getLines (rowContent) {
      let lines = 1
      this.fields.forEach(field => {
        const content = rowContent[field.key]
        if (typeof content === 'object' && content.length > lines) {
          console.debug(' Object ' + content.length)
          lines = content.length
        } else if (typeof content === 'string') {
          const c = this.cleanContent(content)
          const l = c.trim('\n').split('\n').length
          if (l > lines) {
            console.debug(' String ' + l)
            lines = l
          }
        }
      })
      return lines
    },
    cleanContent (content) {
      content = content.replace(/<sup>2<\/sup>/gi, '²')
      content = content.replace(/<sup>3<\/sup>/gi, '³')
      content = content.replace(/<\/?su[bp]>/gi, '')
      return content.replace(/\s*<br *\/? *>\s*/gi, '\n')
    },
    makePDF () {
      const item = this.modalItem
      const size = 100
      const img = document.getElementById('kaavio_' + item.id)
      const ratio = img.width / img.height
      const start = 10
      const rowHeight = 5
      const padding = 2
      const xOffset = 3
      const yOffset = 5
      // eslint-disable-next-line
      const doc = new jsPDF({
        orientation: 'portrait'
      })

      doc.addFileToVFS('LiberationSans.ttf', LiberationSans)
      doc.addFileToVFS('LiberationSans-bold.ttf', LiberationSansBold)
      doc.addFont('LiberationSans.ttf', 'LiberationSans', 'normal')
      doc.addFont('LiberationSans-bold.ttf', 'LiberationSans', 'bold')

      doc.setFont('LiberationSans', 'normal')
      doc.setFont('LiberationSans', 'bold')

      let pos = [start, 10]

      doc.setFontSize(12)
      doc.text(item.acf.tunnus, start, pos[1])

      doc.setFontSize(9)
      const width = ratio < 1 ? size * ratio : size
      const height = ratio < 1 ? size : size / ratio
      pos[1] += 5
      doc.addImage(img, 'PNG', (210 - width) / 2, pos[1], width, height)

      pos[1] += 110
      this.drawHeader(doc, pos, rowHeight + padding, xOffset, yOffset)
      let actualHeight = rowHeight + padding
      item.acf.diagram.forEach((rowContent, rowNr) => {
        pos[0] = start
        pos[1] += actualHeight
        actualHeight = this.getLines(rowContent) * rowHeight + padding
        this.fields.forEach((field, col) => {
          const content = this.formatContent(rowContent[field.key], rowNr)
          doc.setDrawColor(0, 0, 0, 120)
          doc.setFillColor(0, 0, 0, 60)
          doc.rect(pos[0], pos[1], field.width, actualHeight, rowNr % 2 ? 'S' : 'DF')
          doc.setDrawColor(0, 0, 0, 250)
          doc.text(content, pos[0] + xOffset, pos[1] + yOffset)
          pos[0] += field.width
        })
      })
      pos[1] += actualHeight + yOffset
      doc.text(this.cleanContent(item.acf.lisatiedot), start, pos[1])

      doc.save(item.acf.tunnus + '.pdf')
    }
  }
}
</script>
<style scoped>
  .tyypit-row{
    position: relative;
  }

  .tyypit .col-2 {
    border: 1px solid #dee2e6;
    height: 150px;
    display: flex;
    padding: 1em;
    justify-content: center;
    align-items: center;
  }

  .tyypit img {
    cursor: pointer;
    max-height: 100%;
  }

  .tyypit:nth-of-type(even) .col-2 {
    background: rgba(0, 0, 0, 0.05);
  }

  .tyypit:nth-child(2) .row-label {
    border-top-left-radius: 10px;
  }

  .tyypit:nth-child(2) .col-2:last-child {
    border-top-right-radius: 10px;
  }

  .tyypit:nth-child(5) .row-label {
    border-bottom-left-radius: 10px;
  }

  .tyypit:last-child :last-child {
    border-bottom-right-radius: 10px;
  }

  .scroll-buttons {
    position: absolute;
    bottom: 10px;
  }

  .page-button {
    cursor: pointer;
    color: #9ea3a8;
  }
  .page-button:hover{
    color: #007bff;
  }

  .prev-wrapper{
    position: absolute;
    left: -15px;
    top: 60px;
  }

  .next-wrapper{
    position: absolute;
    right: -15px;
    top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tyypit.vue